<template>
    <div class="container-fluid">
        <div class="client-app-inc" style="height:200px" v-if="loading">
            <Loader></Loader>
        </div>
        <slot v-if="!loading">
            <div v-if="is_script" v-html-js="{html: game_data, script:'javascript'}"></div>
            <iframe v-if="!is_script" :src="game_url" style="height:1000px" frameborder="0" width="100%"/>
        </slot>
    </div>
</template>
<style>
    #app.mobile .container-fluid>iframe {
        height: var(--mobileHeight) !important;
    }
</style>
<script>
    export default {
        name: 'Sportsbook',
        metaInfo () {
            return {
                meta: [
                { 'http-equiv':'Content-Security-Policy', content: "upgrade-insecure-requests" },
                ]
            }
        },
        data: function() {
            return {
                loading: false,
                game_url: null,
                game_data: null,
                is_script: false,
            }
        },
        created: function () {
            this.fetchData();
            if(this.isMobile){
                document.querySelector("body").style.setProperty('--mobileHeight', window.innerHeight - 120 + 'px');
            }
        },

        beforeCreate(){
            console.log(this.$store.getters['auth/user_detail'].detail)
            if(this.$store.getters['auth/user_detail'].detail.sport_provider == 2){
                this.$router.push('/inplay')
            }
            if(this.$store.getters['auth/user_detail'].detail.sport_provider == 3){
                this.$router.push('/sportmaintenance')
            }
            if(this.$store.getters['auth/user_detail'].detail.sport_provider == 4){
                this.$router.push('/sportmaintenance')
            }
        },


        methods: {
            fetchData: function() {
                this.loading = true;
                axios.get('/sportsbook', { params: { mobile : this.isMobile }})
                .then((response)=>{
                    this.loading = false;
                    this.is_script = response.data.config.is_script
                    if(this.is_script){
                        this.game_data = response.data.data
                    }else{
                        this.game_url = response.data.config.url
                    }   
                    window.dispatchEvent(new Event('resize'));
                })
                .catch((err)=>{
                });

            },

        }
    }
</script>